<template>
  <GridContainer>
    <GridRow align-h="center">
      <GridColumn :md="8">
        <Heading
          tag="h2"
          size="lg"
          text-uppercase
          align="center"
          class="google-faq__heading"
          >Fragen & Antworten</Heading
        >
        <AccordionItem
          v-for="(faq, key) in faqs"
          :key="key"
        >
          <template #title>
            <Heading tag="h3">
              {{ faq.title }}
            </Heading>
          </template>
          <template #content>
            <Paragraph>
              {{ faq.content }}
            </Paragraph>
          </template>
        </AccordionItem>
      </GridColumn>
    </GridRow>
  </GridContainer>
</template>

<script>
import {
  AccordionItem,
  GridContainer,
  GridRow,
  GridColumn,
  Heading,
  Paragraph,
} from '@i22/td-longtail-vue-components';

export default {
  title: 'GoogleFaq',
  components: {
    AccordionItem,
    GridContainer,
    GridRow,
    GridColumn,
    Heading,
    Paragraph,
  },
  props: {
    faqs: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.google-faq {
  &__heading {
    margin-bottom: 1.125rem;
  }
}
</style>
